import { useGetOne } from "venue-react"

export const useGetEvent = (id) => {
  return useGetOne("event", id, { populate: true })
}
